import React from "react";
import { Link } from "react-router-dom";
import { BRAND, CORE_PROMISE } from "@/lib/content";
import { Linkedin, Twitter, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0D3C4C] text-[#FEF7E7] mt-24">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-[#F1551D] grid place-items-center font-display text-white text-sm">N</span>
              <span className="font-display text-xl">N<span className="text-[#F0A315]">360</span></span>
            </div>
            <p className="text-sm text-[#FEF7E7]/70 leading-relaxed mb-5">A trusted global network of verified leaders — bridging today, transforming tomorrow. One network. One purpose. One future.</p>
            <div className="flex items-center gap-3">
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-white/20 grid place-items-center hover:border-[#F0A315] hover:text-[#F0A315] transition-colors"><Linkedin className="w-4 h-4" /></a>
              <a href="#" aria-label="X" className="w-9 h-9 rounded-full border border-white/20 grid place-items-center hover:border-[#F0A315] hover:text-[#F0A315] transition-colors"><Twitter className="w-4 h-4" /></a>
              <a href="#" aria-label="Mail" className="w-9 h-9 rounded-full border border-white/20 grid place-items-center hover:border-[#F0A315] hover:text-[#F0A315] transition-colors"><Mail className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg mb-4 text-[#F0A315]">Explore</h4>
            <ul className="space-y-2.5 text-sm text-[#FEF7E7]/75">
              <li><a href="/#ecosystem" className="hover:text-white transition-colors">Ecosystem</a></li>
              <li><a href="/#engine" className="hover:text-white transition-colors">Intelligence Engine</a></li>
              <li><a href="/#programs" className="hover:text-white transition-colors">15 Programs</a></li>
              <li><a href="/#access" className="hover:text-white transition-colors">Access & Tiers</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg mb-4 text-[#F0A315]">Network</h4>
            <ul className="space-y-2.5 text-sm text-[#FEF7E7]/75">
              <li><Link to="/signup" className="hover:text-white transition-colors">Request Clearance</Link></li>
              <li><Link to="/login" className="hover:text-white transition-colors">Member Sign In</Link></li>
              <li><a href="/#programs" className="hover:text-white transition-colors">Referral System</a></li>
              <li><a href="/#engine" className="hover:text-white transition-colors">Verification & Trust</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg mb-4 text-[#F0A315]">Contact</h4>
            <ul className="space-y-3 text-sm text-[#FEF7E7]/75">
              <li className="flex items-center gap-2.5"><Mail className="w-4 h-4 text-[#F0A315] shrink-0" /> concierge@n360.network</li>
              <li className="flex items-center gap-2.5"><Phone className="w-4 h-4 text-[#F0A315] shrink-0" /> +91 (0) 22 6000 3600</li>
              <li className="flex items-start gap-2.5"><MapPin className="w-4 h-4 text-[#F0A315] shrink-0 mt-0.5" /> N360 Sovereign House, Global Network</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
          {CORE_PROMISE.map((c) => (
            <div key={c.t} className="text-center">
              <div className="font-display text-[#F0A315] text-base">{c.t}</div>
              <div className="text-[11px] text-[#FEF7E7]/55">{c.d}</div>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#FEF7E7]/55">© {year} N360 Global Network. All rights reserved.</p>
          <p className="text-xs text-[#FEF7E7]/55 tracking-wide">{BRAND.tagline} — {BRAND.sub}</p>
        </div>
      </div>
    </footer>
  );
}
